import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import deleteIcon from '../../assets/delete.png';
import { 
  Button, 
  TextField, 
  Select, 
  MenuItem, 
  Typography, 
  IconButton, 
  FormControl, 
  InputLabel, 
  Paper,
  Dialog, 
  DialogTitle, 
  DialogContent,
  DialogActions, 
  List, 
  ListItem, 
  ListItemText,
  Box,
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  FormControlLabel,
  StepConnector,
  Divider,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import loadingGif from '../../assets/loading.gif';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useWebSocket } from '../ws/WebsocketContext';

import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Tooltip from '@mui/material/Tooltip';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import BusinessIcon from '@mui/icons-material/Business';
import LanguageIcon from '@mui/icons-material/Language';

import API_BASE_URL from '../../config';
import './Order.css';

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  '&.MuiStepConnector-root': {
    top: 12,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  '& .MuiStepConnector-line': {
    borderColor: theme.palette.primary.light,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const PulsingDot = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: 24,
  height: 24,
  borderRadius: '50%',
  background: 'rgba(25, 118, 210, 0.2)',
  border: `3px solid ${theme.palette.primary.main}`,
  boxSizing: 'border-box',
  position: 'relative',
  animation: 'pulseBorder 1s infinite',
  '@keyframes pulseBorder': {
    '0%': { boxShadow: `0 0 0 0 ${theme.palette.primary.main}` },
    '70%': { boxShadow: `0 0 0 8px rgba(25, 118, 210, 0.2)` },
    '100%': { boxShadow: `0 0 0 0 rgba(25, 118, 210, 0)` },
  },
}));

function CustomStepIcon(props) {
  const { active, completed } = props;
  if (active) {
    return <PulsingDot />;
  }
  return completed ? (
    <CheckCircleIcon color="primary" />
  ) : (
    <RadioButtonUncheckedIcon color="disabled" />
  );
}

const FlameToggle = styled('span')(({ theme, urgent }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '4px 12px',
  borderRadius: '20px',
  background: urgent ? 'rgba(255, 213, 79, 0.2)' : 'rgba(0,0,0,0.04)',
  border: urgent ? '2px solid #FFD54F' : '2px solid #e0e0e0',
  transition: 'background 0.3s, border 0.3s',
  boxShadow: urgent ? '0 0 8px 2px #FFD54F' : 'none',
}));
const AnimatedFlame = styled(WhatshotIcon)(({ urgent }) => ({
  color: urgent ? '#d35400' : '#BDBDBD',
  fontSize: 28,
  animation: urgent ? 'flamePulse 1s infinite' : 'none',
  '@keyframes flamePulse': {
    '0%': { filter: 'drop-shadow(0 0 0 #d35400F)' },
    '70%': { filter: 'drop-shadow(0 0 8px #d35400)' },
    '100%': { filter: 'drop-shadow(0 0 0 #d35400)' },
  },
}));


const EventPanel = ({ date, events, onClose, onAddEvent, handleEventClick }) => {
  return (
    <Paper 
      elevation={3} 
      style={{
        height: '40%',
        minHeight: '40%',
        maxHeight: '40%',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        marginBottom: '10px'
      }}
    >
      {/* Fixed header */}
      <div 
        style={{ 
          height: 56,
          flexShrink: 0,
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          padding: '0 16px',
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          zIndex: 10,
        }}
      >
        <Typography variant="h6">{date.toDateString()}</Typography>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={onAddEvent}
            size="small"
          >
            Add Event
          </Button>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>

      {/* Scrollable list */}
      <div style={{ flexGrow: 1, overflowY: 'auto', minHeight: 0 }}>
        <List>
          {events.length > 0 ? (
            events.map((event) => (
              <ListItem 
                key={event.eventId} 
                divider 
                button 
                onClick={() => handleEventClick(event)}
                style={{ cursor: 'pointer', alignItems: 'center' }}
              >
                {/* Color dot */}
                <div 
                  style={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    backgroundColor: event.color || '#6c757d', 
                    marginRight: 12, 
                    flexShrink: 0 
                  }} 
                />
                <ListItemText 
                  primary={event.title}
                  secondary={`${event.eventType} | ${new Date(event.start).toLocaleString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })} - ${new Date(event.end).toLocaleString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })} | Note: ${event.description || 'N/A'}`}
                />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No events for this day." />
            </ListItem>
          )}
        </List>
      </div>
    </Paper>
  );
};

const CreateNewOrder = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const orgId = localStorage.getItem('selectedOrg');
  const token = localStorage.getItem('token');
  
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);

  const [layoutMode, setLayoutMode] = useState('split'); // 'order', 'calendar', 'split'

  const [events, setEvents] = useState([]);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateEvents, setSelectedDateEvents] = useState([]);

  const [createEventDialogOpen, setCreateEventDialogOpen] = useState(false);
  const [newEventTitle, setNewEventTitle] = useState('');
  const [newEventStart, setNewEventStart] = useState(null);
  const [newEventEnd, setNewEventEnd] = useState(null);
  const [newEventDescription, setNewEventDescription] = useState('');
  const [newEventType, setNewEventType] = useState('');
  const [newEventColor, setNewEventColor] = useState('#007bff');
  const [newEventLocation, setNewEventLocation] = useState('');
 
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState('');

  const steps = ['Customer', 'Order', 'Job', 'Review'];
  const [activeStep, setActiveStep] = useState(0);

  const [maxJob, setMaxJob] = new useState(0);
  const [prefixMap, setPrefixMap] = useState(true);
  const [companyMap, setCompanyMap] = new useState([]);
  const [customerMap, setCustomerMap] = new useState([]);
  const [companyCustomerMap, setCompanyCustomerMap] = new useState([]);

  // Step 1: Customer
  const [selectedCompany, setSelectedCompany] = useState('0');
  const [selectedCompanyCustomer, setSelectedCompanyCustomer] = useState('0');
  const [selectedCustomer, setSelectedCustomer] = useState('0');
  const [customerType, setCustomerType] = useState('company');

  const [companyName, setCompanyName] = useState('');
  const [companyNumber, setCompanyNumber] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');

  const [companyCustomerName, setCompanyCustomerName] = useState('');
  const [companyCustomerNumber, setCompanyCustomerNumber] = useState('');
  const [companyCustomerEmail, setCompanyCustomerEmail] = useState('');

  const [customerName, setCustomerName] = useState('');
  const [customerNumber, setCustomerNumber] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');

  // Step 2: Order
  const [jobFlow, setJobFlow] = useState([]);
  const [selectedJobFlow, setSelectedJobFlow] = useState("");
  const [orderPrefix, setOrderPrefix] = useState('');
  const [tag1Name, setTag1Name] = useState('tag1');
  const [tag2Name, setTag2Name] = useState('tag2');
  const [tag3Name, setTag3Name] = useState('tag3');
  const [tag4Name, setTag4Name] = useState('tag4');
  const [tag5Name, setTag5Name] = useState('tag5');
  const [tag6Name, setTag6Name] = useState('tag6');
  const [tag7Name, setTag7Name] = useState('tag7');
  const [tag8Name, setTag8Name] = useState('tag8');
  const [tag1, setTag1] = useState(false);
  const [tag2, setTag2] = useState(false);
  const [tag3, setTag3] = useState(false);
  const [tag4, setTag4] = useState(false);
  const [tag5, setTag5] = useState(false);
  const [tag6, setTag6] = useState(false);
  const [tag7, setTag7] = useState(false);
  const [tag8, setTag8] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [purchaseOrder, setPurchaseOrder] = useState('');
  const [quoteNumber, setQuoteNumber] = useState('');
  const [folderPath, setFolderPath] = useState('');
  const [orderDescription, setOrderDescription] = useState('');
  const [address, setAddress] = useState('');
  const [suburb, setSuburb] = useState('');
  const [state, setState] = useState('');
  const [postalCode, setPostalCode] = useState('');

  // Step 3: Job
  const [jobs, setJobs] = useState([{ 
    id: 1, 
    jobName: '', 
    urgent: false, 
    jobNote: '', 
    jobDescription: '', 
    product: [], 
    price: 0 
  }]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [allProductsDialogOpen, setAllProductsDialogOpen] = useState(false);
  const [selectedProductJobId, setSelectedProductJobId] = useState('');
  const [allProducts, setAllProducts] = useState([]);
  const [currentEditingJobId, setCurrentEditingJobId] = useState(null);
  const [editingJobProducts, setEditingJobProducts] = useState([]);

  const [productSearchTerm, setProductSearchTerm] = React.useState('');
  const filteredProducts = categories.flatMap(category => 
    category.items.map(item => ({
      ...item,
      product_category_id: category.product_category_id,
      product_category_name: category.product_category_name,
      departmentName: category.product_department_name || '', // Add if available
      categoryName: category.product_category_name,
      // Look up unit symbol from units state
      item_unit: item.item_unit
    }))
  ).filter(product => {
    const search = productSearchTerm.toLowerCase();
    return (
      product.item_name.toLowerCase().includes(search) ||
      product.product_category_name.toLowerCase().includes(search) ||
      (product.departmentName && product.departmentName.toLowerCase().includes(search))
    );
  }).sort((a, b) => {
    // First sort by department
    if (a.departmentName < b.departmentName) return -1;
    if (a.departmentName > b.departmentName) return 1;
    
    // Then by category
    if (a.categoryName < b.categoryName) return -1;
    if (a.categoryName > b.categoryName) return 1;
    
    // Finally by product name
    if (a.item_name < b.item_name) return -1;
    if (a.item_name > b.item_name) return 1;
    
    return 0;
  });
  const [loadingProducts, setLoadingProducts] = useState(false);

  const closeAllProductsDialog = () => {
    setAllProductsDialogOpen(false);
    setAllProducts([]);
    setEditingJobProducts([]);
    setCurrentEditingJobId(null);
  };

  const handleProductQuantityChange = (productId, quantity) => {
    console.log(productId, quantity);
    setEditingJobProducts(prev => {
      const existing = prev.find(p => p.job_product_id === productId || p.product_item_id === productId);
      if (existing) {
        return prev.map(p => (p.job_product_id === productId || p.product_item_id === productId ? { ...p, quantity: Number(quantity) } : p));
      } else {
        // Add new product with quantity
        return [...prev, { 
          product_item_id: productId, 
          item_name: filteredProducts.find(p => p.product_item_id === productId)?.item_name || '',
          item_price: filteredProducts.find(p => p.product_item_id === productId)?.item_price || 0,
          item_unit: filteredProducts.find(p => p.product_item_id === productId)?.item_unit || '',
          item_stock: filteredProducts.find(p => p.product_item_id === productId)?.item_stock || 0,
          quantity: Number(quantity) 
        }];
      }
    });
  };

  const handleCustomerTypeChange = (type) => {
    setCustomerType(type);
    if (type === 'company') {
      setCustomerName('');
      setCustomerNumber('');
      setCustomerEmail('');
    } else {
      setCompanyName('');
      setCompanyNumber('');
      setCompanyEmail('');
      setCompanyCustomerName('');
      setCompanyCustomerNumber('');
      setCompanyCustomerEmail('');
    }
  };

  const saveJobProducts = async () => {

    const nonZeroProducts = editingJobProducts.filter(p => p.quantity > 0);

    const totalPrice = nonZeroProducts.reduce((sum, product) => {
      return sum + (product.quantity * product.item_price);
    }, 0);

    setJobs((prevJobs) => {
      return prevJobs.map((job) => {
        if (job.id === selectedProductJobId) {
          return {
            ...job,
            product: nonZeroProducts,
            price: totalPrice.toFixed(2),
          };
        }
        return job;
      });
    });

    setSelectedProductJobId('');
    closeAllProductsDialog();
    setEditingJobProducts([]);

    /*
    try {
      const payload = {
        jobId: currentEditingJobId,
        products: editingJobProducts.map(p => ({
          product_item_id: p.product_item_id || p.job_product_id,
          quantity: p.quantity,
        })),
        orderId: order.order_id,
      };

      const res = await axios.post(`${API_BASE_URL}/orders/update-job-products`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      toast.success('Job products updated successfully.');
      fetchOrder();
      closeAllProductsDialog();
    } catch (error) {
      toast.error('Failed to update job products.');
      console.error('Error updating job products:', error);
    }
    */
  };

  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
      document.title = "Create Order - IMS";
      
      return () => {
        document.title = "IMS";
      };
    }, []);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      setLoading1(true);

      if (!token) {
          navigate('/unauthorized');
          return;
      }
      try {
        // Check if existing orders exceed limit, return max job per order while within limit, and permission
        const response = await axios.get(`${API_BASE_URL}/orders/max-order-jobs`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (response.status === 403) {
            navigate('/unauthorized');
            return;
        }

        if (response.status === 203) {
          setLoading1(false);
          await Swal.fire({
              title: 'Maximum Order Reached',
              text: 'You have reached the maximum number of jobs allowed under current plan. Please remove existing order or upgrade plan before adding more.',
              icon: 'warning',
              confirmButtonText: 'Back',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: false
          }).then((result) => {
            if (result.isConfirmed) {
              navigate('/dashboard');
            }
          });
          return;
        }

        setMaxJob(response.data);

        // Fetch company/customer details
        const customerResponse = await axios.get(`${API_BASE_URL}/orders/customers`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (!(customerResponse.status === 204 || !customerResponse.data || customerResponse.data.length === 0)) {
          // Separate customers and companies
          const customers = customerResponse.data
            .filter(item => item.customer_id !== null)
            .map(item => ({ 
              id: item.customer_id, 
              name: item.customer_name,
              number: item.customer_number,
              email: item.customer_email
          }));

          const companies = customerResponse.data
            .filter(item => item.company_id !== null)
            .map(item => ({ 
              id: item.company_id, 
              name: item.company_name,
              number: item.company_number,
              email: item.company_email,
              website: item.company_website
          }));

          // Append new data to existing state
          setCustomerMap(prevCustomerMap => {
            const existingCustomerIds = new Set(prevCustomerMap.map(customer => customer.id));
            const uniqueCustomers = customers.filter(customer => !existingCustomerIds.has(customer.id));
            return [...prevCustomerMap, ...uniqueCustomers];
          });
        
          setCompanyMap(prevCompanyMap => {
            const existingCompanyIds = new Set(prevCompanyMap.map(company => company.id));
            const uniqueCompanies = companies.filter(company => !existingCompanyIds.has(company.id));
            return [...prevCompanyMap, ...uniqueCompanies];
          });
        }

        // Fetch job flows
        const jobFlowResponse = await axios.get(`${API_BASE_URL}/orders/job-flow`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (jobFlowResponse.status === 204 || !jobFlowResponse.data || jobFlowResponse.data.length === 0) {
          await Swal.fire({
            title: 'No Job Flow Found',
            text: 'Please create a job flow before creating an order.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          navigate('/dashboard');
          return;
        }

        setJobFlow(jobFlowResponse.data);
        setSelectedJobFlow(jobFlowResponse.data.find((flow) => flow.default_job_flow === 1)?.id || "");

        // Fetch order prefix
        const prefixResponse = await axios.get(`${API_BASE_URL}/orders/prefix`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (prefixResponse.status === 204 || !prefixResponse.data || prefixResponse.data.length === 0) {
          await Swal.fire({
            title: 'No Prefix Found',
            text: 'Please create a prefix before creating an order.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          navigate('/dashboard');
          return;
        }

        setOrderPrefix(prefixResponse.data[0].prefix);
        setPrefixMap(prefixResponse.data);

        // Fetch tags names
        const tagsResponse = await axios.get(`${API_BASE_URL}/orders/tags`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (tagsResponse.status === 204 || !tagsResponse.data || tagsResponse.data.length === 0) {
          await Swal.fire({
            title: 'No Tag Found',
            text: 'Please create a tag before creating an order.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          navigate('/dashboard');
          return;
        };

        const tags = tagsResponse.data;

        tags.map(tag => {
          if (tag.tagIndex === 'tag1') setTag1Name(tag.tagName);
          if (tag.tagIndex === 'tag2') setTag2Name(tag.tagName);
          if (tag.tagIndex === 'tag3') setTag3Name(tag.tagName);
          if (tag.tagIndex === 'tag4') setTag4Name(tag.tagName);
          if (tag.tagIndex === 'tag5') setTag5Name(tag.tagName);
          if (tag.tagIndex === 'tag6') setTag6Name(tag.tagName);
          if (tag.tagIndex === 'tag7') setTag7Name(tag.tagName);
          if (tag.tagIndex === 'tag8') setTag8Name(tag.tagName);
        });

        // Fetch units
        const unitsResponse = await axios.get(`${API_BASE_URL}/orders/units`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (unitsResponse.status === 204 || !unitsResponse.data || unitsResponse.data.length === 0) {
          await Swal.fire({
            title: 'No Units Found',
            text: 'Please contact admin for more info.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          navigate('/dashboard');
          return;
        }

        setUnits(unitsResponse.data);

        // Fetch products
        const productsResponse = await axios.get(`${API_BASE_URL}/orders/products`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (productsResponse.status === 204 || !productsResponse.data) {
          await Swal.fire({
            title: 'No Products Found',
            text: 'Please contact system admin for more info.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          navigate('/dashboard');
          return;
        }

        if (productsResponse.data.length !== 0) {
          setCategories(productsResponse.data);
        }
        

        // Fetch events
        const eventResponse = await axios.get(`${API_BASE_URL}/event/all-events`, {
          headers: {
            Authorization: `Bearer ${token}`,
            selectedorg: orgId,
          },
        });

        if (eventResponse.status === 204 || !eventResponse.data || eventResponse.data.length === 0) {
          await Swal.fire({
            title: 'Error Finding Events',
            text: 'Please contact system admin for more info.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          navigate('/dashboard');
          return;
        }

        setEvents(eventResponse.data.events.map(event => ({
          eventId: event.event_id,
          title: event.title,
          start: new Date(event.start_datetime),
          end: new Date(event.end_datetime),
          description: event.description,
          location: event.location,
          eventType: event.event_type,
          color: event.color,
        })));

      } catch (error) {
          console.error('Error fetching data:', error);
          navigate('/unauthorized');
          return;
      } finally {
          setLoading1(false);
      }
    };

    fetchOrderDetails();
  }, [orgId, navigate]);  

  useEffect(() => {
    const fetchOrderForReorder = async () => {
      if (orderId && orderId !== '0') {
        try {
          setLoading1(true);
          const response = await axios.get(`${API_BASE_URL}/orders/reorder/${orderId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              selectedorg: orgId,
            },
          });

          if (response.data) {
            const orderData = response.data[0];
            
            console.log(orderData);

            if (orderData.order_company_id) {
              setCustomerType('company');
            } else {
              setCustomerType('individual');
            }

            // If company exist, register company
            if (orderData.order_company_id) {
              const company = companyMap.find(company => company.id === orderData.order_company_id);
              
              setSelectedCompany(company?.id || '');
              setCompanyName(company?.name || '');
              setCompanyNumber(company?.number || '');
              setCompanyEmail(company?.email || '');
              setCompanyWebsite(company?.website || '');

              // If company exist, register company customer
              if (orderData.order_customer_id) {
                const companyCustomers = await fetchCompanyCustomers(company?.id || '');
                const customer = companyCustomers.find(c => c.id === orderData.order_customer_id);
                setSelectedCompanyCustomer(customer?.id || '0');
                setCompanyCustomerName(customer?.name || '');
                setCompanyCustomerNumber(customer?.number || '');
                setCompanyCustomerEmail(customer?.email || '');
              }

            } else {
              // If company doesn't exist, register customer
              if (orderData.order_customer_id) {
                const customer = customerMap.find(c => c.id === orderData.order_customer_id);
                setSelectedCustomer(customer?.id || '0');
                setCustomerName(customer?.name || '');
                setCustomerNumber(customer?.number || '');
                setCustomerEmail(customer?.email || '');
              }
            }

            setSelectedJobFlow(orderData.job_flow);
            setOrderPrefix(orderData.prefix || '');

            setTag1(orderData.tag1 === 1);
            setTag2(orderData.tag2 === 1);
            setTag3(orderData.tag3 === 1);
            setTag4(orderData.tag4 === 1);

            setInvoiceNumber(orderData.invoice_number || '');
            setPurchaseOrder(orderData.purchase_order_number || '');
            setQuoteNumber(orderData.quote || '');
            setFolderPath(orderData.folder_path || '');
            setOrderDescription(orderData.order_description || '');

            setAddress(orderData.street_address || '');
            setSuburb(orderData.suburb || '');
            setState(orderData.state || '');
            setPostalCode(orderData.postal_code || '');

            const newJobs = orderData.jobs.map((job, index) => ({
              id: index + 1,
              jobName: job.job_name || '',
              jobDescription: job.job_description || '',
              urgent: job.urgent === 1,
              price: job.price || 1,
              product: job.products || []
            }));
            
            // Set all jobs at once
            setJobs(newJobs);

          }
        } catch (error) {
          console.error('Error fetching order details for reorder:', error);
          toast.error('Failed to load order details for reorder');
        } finally {
          setLoading1(false);
        }
      }
    };

    fetchOrderForReorder();
  }, [orderId, token, orgId, companyMap, customerMap]);

  const handleCompanyChange = (companyId) => {
    setSelectedCompany(companyId);

    // Clear Company Customer first before performing company change
    setSelectedCompanyCustomer('0');
    setCompanyCustomerName('');
    setCompanyCustomerNumber('');
    setCompanyCustomerEmail('');

    // Clear company & companyCustomer textfields if companyId = 0
    if (companyId === '0') {
      setCompanyName(''); 
      setCompanyNumber('');
      setCompanyEmail('');
      setCompanyWebsite('');
    } else {
      // Fill company textfields with selected company's details
      const selectedCompany = companyMap.find((company) => company.id === companyId);
      if (selectedCompany) {
        setCompanyName(selectedCompany.name || ' ');
        setCompanyNumber(selectedCompany.number || ' ');
        setCompanyEmail(selectedCompany.email || ' ');
        setCompanyWebsite(selectedCompany.website || ' ');
      }
      fetchCompanyCustomers(selectedCompany.id);
    }
  };
  
  const fetchCompanyCustomers = async (companyId) => {
    try {
      const customerResponse = await axios.get(`${API_BASE_URL}/orders/customers/company/${companyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      // Check if no customers are returned
      if (customerResponse.data && customerResponse.data.length === 0) {
        setCompanyCustomerMap([]);
        return;
      }
  
      const customers = customerResponse.data
        .filter(item => item.customer_id !== null)
        .map(item => ({
          id: item.customer_id,
          name: item.customer_name,
          number: item.customer_number,
          email: item.customer_email
        }));

      setCompanyCustomerMap(customers);
      return customers;

    } catch (error) {
      console.error('Error fetching company customers:', error);
    }
  };
  
  const handleCompanyCustomerChange = (customerId) => {
    setSelectedCompanyCustomer(customerId);

    // Clear company customer textfields if companyId = 0
    if (customerId === '0') {
      setCompanyCustomerName('');
      setCompanyCustomerNumber('');
      setCompanyCustomerEmail('');
    }

    // Fill company customer textfields with selected company's details
    const selectedCompanyCustomer= companyCustomerMap.find((customer) => customer.id === customerId);
    if (selectedCompanyCustomer) {
      setCompanyCustomerName(selectedCompanyCustomer.name || ' ');
      setCompanyCustomerNumber(selectedCompanyCustomer.number || ' ');
      setCompanyCustomerEmail(selectedCompanyCustomer.email || ' ');
    }
  }
  
  const handleCustomerChange = (customerId) => {
    setSelectedCustomer(customerId);
    // Clear customer textfields if customerId = 0
    if (customerId === '0') {
      setCustomerName('');
      setCustomerNumber('');
      setCustomerEmail('');
    }

    // Fill customer textfields with selected customer's details
    const selectedCustomer= customerMap.find((customer) => customer.id === customerId);
    if (selectedCustomer) {
      setCustomerName(selectedCustomer.name || ' ');
      setCustomerNumber(selectedCustomer.number || ' ');
      setCustomerEmail(selectedCustomer.email || ' ');
    }
  }

  const handleOrderPrefixChange = (prefix) => {
    setOrderPrefix(prefix);
  }

  // Add a new job
  const addJob = () => {
    if (jobs.length < maxJob) {
      setJobs([
        ...jobs,
        {
          id: jobs.length + 1,
          name: '',
          description: '',
          product: []
        }
      ]);
    }
  };

  // Delete job function
  const deleteJob = (id) => {
    if (jobs.length === 1) {
      // Show alert if trying to delete the last job
      Swal.fire({
        title: 'Cannot Delete Last Job',
        text: "You cannot delete the last job. Please add a new job before deleting this job.",
        icon: 'error',
        confirmButtonText: 'Got it!',
      });
    } else {
      // If there are more than one job, delete it
      setJobs(jobs.filter((job) => job.id !== id));
    }
  };

  // Update job details
  const updateJob = (id, key, value) => {
    setJobs(jobs.map(job => job.id === id ? { ...job, [key]: value } : job));
  };

  const addProductToJob = (product, jobId) => {
    setJobs((prevJobs) => {
      return prevJobs.map((job) => {
        if (job.id === jobId) {
          const existingProductIndex = job.product.findIndex(
            (p) => p.product_item_id === product.product_item_id
          );
  
          if (existingProductIndex === -1) {
            return {
              ...job,
              product: [...job.product, { ...product, quantity: 1 }],
            };
          }
        }
        return job;
      });
    });
  };

  // Function to handle quantity change for a product
  const handleQuantityChange = (productId, quantity, jobId) => {
    setJobs((prevJobs) =>
      prevJobs.map((job) =>
        job.id === jobId
          ? {
              ...job,
              product: job.product.map((product) =>
                product.product_item_id === productId
                  ? { ...product, quantity }
                  : product
              ),
            }
          : job
      )
    );
  };

  // Function to remove product from a job
  const removeProductFromJob = (productId, jobId) => {
    setJobs((prevJobs) =>
      prevJobs.map((job) =>
        job.id === jobId
          ? {
              ...job,
              product: job.product.filter((product) => product.product_item_id !== productId),
              price: job.product
                .filter((product) => product.product_item_id !== productId)
                .reduce((sum, product) => sum + (product.quantity * product.item_price), 0)
                .toFixed(2),
            }
          : job
      )
    );
  };

  // Function to get unit name from the mockUnits array
  const getUnitNameById = (unitId) => {
    const unit = units.find(unit => unit.id === unitId);
    return unit ? unit.symbol : '';
  };

  const handleSubmitOrder = async () => {
      if (customerType === 'company') {
        let orderCompanyId = selectedCompany;
        let orderCompanyCustomerId = selectedCompanyCustomer;
  
        if (selectedCompany === '0') {
          try {
  
            const payload = {
              companyName,
              companyNumber,
              companyEmail,
              companyWebsite
            };
            // Find duplicate companies if any
            const duplicateCompanyResponse = await axios.post(`${API_BASE_URL}/customers/check-duplicate-company`, payload, {
              headers: {
                  Authorization: `Bearer ${token}`,
                  SelectedOrg: orgId,
                  'Content-Type': 'application/json',
              },
            });
  
            if (duplicateCompanyResponse.data.duplicates && duplicateCompanyResponse.data.duplicates.length > 0) {
              const duplicateCompanyDetails = duplicateCompanyResponse.data.duplicates
                  .map(dup => {
                      const matchingFields = dup.matchingFields ? dup.matchingFields.join(', ') : 'No matching fields specified';
                      
                      return `Customer ID: ${dup.customer_id}\nDuplicate fields: ${matchingFields}.\n`;
                  })
                  .join('\n');
          
              const confirmResult = await Swal.fire({
                  title: 'Duplicate Found!',
                  text: `A company with similar information already exists. Details:\n\n${duplicateCompanyDetails}\n\nDo you still want to create this customer?`,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, create anyway',
                  cancelButtonText: 'Cancel',
              });
          
              if (!confirmResult.isConfirmed) {
                  return;
              }
            }
  
            // Create new company if company does not exist
            const companyResponse = await axios.post(
              `${API_BASE_URL}/orders/create-company`,
              {
                companyName: companyName,
                companyEmail: companyEmail,
                companyNumber: companyNumber,
                companyWebsite: companyWebsite
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  selectedorg: orgId,
                },
              }
            );
            
            // Set the new company's id to selected company id
            if (companyResponse.data && companyResponse.data.companyId) {
              setSelectedCompany(companyResponse.data.companyId);

              orderCompanyId = companyResponse.data.companyId;
            } else {
              throw new Error('No company ID returned in response');
            }
          } catch (error) {
            console.error("Error creating new company:", error);
            Swal.fire({
              title: 'Failed to Create Company',
              text: error.response?.data?.message || 'An unexpected error occurred. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        }
  
        if (selectedCompanyCustomer === '0') {
          try {
            // Find duplicate company customer if any
            const payload = {
              companyCustomerName,
              companyCustomerNumber,
              companyCustomerEmail,
            };
            const duplicateCompanyCustomerResponse = await axios.post(`${API_BASE_URL}/customers/check-duplicate-company-customer`, payload, {
              headers: {
                  Authorization: `Bearer ${token}`,
                  SelectedOrg: orgId,
                  'Content-Type': 'application/json',
              },
            });
  
            if (duplicateCompanyCustomerResponse.data.duplicates && duplicateCompanyCustomerResponse.data.duplicates.length > 0) {
              const duplicateCompanyCustomerDetails = duplicateCompanyCustomerResponse.data.duplicates
                  .map(dup => {
                      const matchingFields = dup.matchingFields ? dup.matchingFields.join(', ') : 'No matching fields specified';
                      
                      return `Customer ID: ${dup.customer_id}\nDuplicate fields: ${matchingFields}.\n`;
                  })
                  .join('\n');
          
              const confirmResult = await Swal.fire({
                  title: 'Duplicate Found!',
                  text: `A company customer with similar information already exists. Details:\n\n${duplicateCompanyCustomerDetails}\n\nDo you still want to create this customer?`,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, create anyway',
                  cancelButtonText: 'Cancel',
              });
          
              if (!confirmResult.isConfirmed) {
                  return;
              }
            }
  
            // Create new company customer if company customer does not exist
            const companyCustomerRersponse = await axios.post(
              `${API_BASE_URL}/orders/create-company-customer`,
              {
                orderCompanyId,
                companyCustomerName,
                companyCustomerNumber,
                companyCustomerEmail,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  selectedorg: orgId,
                },
              }
            );
            
            // Set the new customer company's id to selected customer company id
            if (companyCustomerRersponse.data && companyCustomerRersponse.data.companyCustomerId) {
              setSelectedCompanyCustomer(companyCustomerRersponse.data.companyCustomerId);
              orderCompanyCustomerId = companyCustomerRersponse.data.companyCustomerId;
            } else {
              throw new Error('No company customer ID returned in response');
            }
          } catch (error) {
            console.error("Error creating new company customer:", error);
            Swal.fire({
              title: 'Failed to Create Company Customer',
              text: error.response?.data?.message || 'An unexpected error occurred. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        }
  
        if (orderCompanyId !== '0' && orderCompanyCustomerId !== '0') {
  
          const companyOrderResponse = await axios.post(
            `${API_BASE_URL}/orders/submit-company-order`,
            {
              selectedJobFlow,
              orderPrefix,
              orderCompanyId,
              orderCompanyCustomerId,
              tag1,
              tag2,
              tag3,
              tag4,
              tag5,
              tag6,
              tag7,
              tag8,
              invoiceNumber,
              purchaseOrder,
              folderPath,
              quoteNumber,
              orderDescription,
              address,
              suburb,
              state,
              postalCode,
              totalPrice,
              jobs
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                selectedorg: orgId,
              },
            }
          );
  
          if (companyOrderResponse.status === 201) {
            Swal.fire({
              title: 'Order Submitted!',
              text: 'Your order has been successfully submitted.',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              navigate('/dashboard');
            });
  
          } else if (companyOrderResponse.status === 429) {
            Swal.fire({
              title: 'Order Limit Reached',
              text: 'You have reached the maximum number of orders allowed for your plan.',
              icon: 'warning',
              confirmButtonText: 'OK',
            });
          } else {
            Swal.fire({
              title: 'Failed to Create Order',
              text: 'There was an issue submitting your order. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
  
        } else {
          Swal.fire({
            title: 'Failed to Create Order',
            text: 'There was an issue submitting your order. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      } else if (customerType === 'individual') {
        let orderIndividualCustomerId = selectedCustomer;
  
        if (selectedCustomer === '0') {
          try {
            // Find duplicate customer if any
            const payload = {
              customerName,
              customerNumber,
              customerEmail,
            };
            const duplicateCustomerResponse = await axios.post(`${API_BASE_URL}/customers/check-duplicate-customer`, payload, {
              headers: {
                  Authorization: `Bearer ${token}`,
                  SelectedOrg: orgId,
                  'Content-Type': 'application/json',
              },
            });
  
            if (duplicateCustomerResponse.data.duplicates && duplicateCustomerResponse.data.duplicates.length > 0) {
              const duplicateCustomerDetails = duplicateCustomerResponse.data.duplicates
                  .map(dup => {
                      const matchingFields = dup.matchingFields ? dup.matchingFields.join(', ') : 'No matching fields specified';
                      
                      return `Customer ID: ${dup.customer_id}\nDuplicate fields: ${matchingFields}.\n`;
                  })
                  .join('\n');
          
              const confirmResult = await Swal.fire({
                  title: 'Duplicate Found!',
                  text: `A customer with similar information already exists. Details:\n\n${duplicateCustomerDetails}\n\nDo you still want to create this customer?`,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, create anyway',
                  cancelButtonText: 'Cancel',
              });
          
              if (!confirmResult.isConfirmed) {
                  return;
              }
            }
  
            // Create new individual customer if individual customer does not exist
            const individualCustomerResponse = await axios.post(
              `${API_BASE_URL}/orders/create-individual-customer`,
              {
                customerName,
                customerNumber,
                customerEmail,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  selectedorg: orgId,
                },
              }
            );
            
            // Set the new customer company's id to selected customer company id
            if (individualCustomerResponse.data && individualCustomerResponse.data.individualCustomerId) {
              setSelectedCompanyCustomer(individualCustomerResponse);
              orderIndividualCustomerId = individualCustomerResponse.data.individualCustomerId;
            } else {
              throw new Error('No individual customer ID returned in response');
            }
          } catch (error) {
            console.error("Error creating new individual customer:", error);
            Swal.fire({
              title: 'Failed to Create Individual Customer',
              text: error.response?.data?.message || 'An unexpected error occurred. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        }
  
        if (orderIndividualCustomerId !== '0') {
  
          const individualOrderResponse = await axios.post( 
            `${API_BASE_URL}/orders/submit-individual-order`,
            {
              selectedJobFlow,
              orderPrefix,
              orderIndividualCustomerId,
              tag1,
              tag2,
              tag3,
              tag4,
              tag5,
              tag6,
              tag7,
              tag8,
              invoiceNumber,
              purchaseOrder,
              quoteNumber,
              folderPath,
              orderDescription,
              address,
              suburb,
              state,
              postalCode,
              totalPrice,
              jobs
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                selectedorg: orgId,
              },
            }
          );
  
          if (individualOrderResponse.status === 201) {
            Swal.fire({
              title: 'Order Submitted!',
              text: 'Your order has been successfully submitted.',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              navigate('/dashboard');
            });
  
          } else {
            Swal.fire({
              title: 'Failed to Create Order',
              text: 'There was an issue submitting your order. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
  
        } else {
          Swal.fire({
            title: 'Failed to Create Order',
            text: 'There was an issue submitting your order. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
  
      } else {
        Swal.fire({
          title: 'Failed to Create Order',
          text: 'There was an issue submitting your order. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    };



  

  const socket = useWebSocket();

  useEffect(() => {
    if (socket && orgId && selectedJobFlow) {
      const subscribeChannels = () => {
        try {
          socket.send(JSON.stringify({
            type: 'subscribe',
            channel: `jobflow:${selectedJobFlow}`
          }));
          socket.send(JSON.stringify({
            type: 'subscribe',
            channel: `create-order:${selectedJobFlow}`
          }));
          console.log(`Subscribed to jobflow:${selectedJobFlow}, create-order:${selectedJobFlow}`);
        } catch (error) {
          console.error('WebSocket subscription error:', error);
        }
      };

      subscribeChannels();

      return () => {
        try {
          socket.send(JSON.stringify({
            type: 'unsubscribe',
            channel: `jobflow:${selectedJobFlow}`
          }));
          socket.send(JSON.stringify({
            type: 'unsubscribe',
            channel: `create-order:${selectedJobFlow}`
          }));
          console.log(`Unsubscribed from jobflow:${selectedJobFlow}, create-order:${selectedJobFlow}`);
        } catch (error) {
          console.error('WebSocket unsubscription error:', error);
        }
      };
    }
  }, [socket, orgId, selectedJobFlow]);


  const handleAddEvent = () => {
  const baseDate = selectedDate ? new Date(selectedDate) : new Date();

  const start = new Date(baseDate);
  start.setHours(7, 30, 0, 0);

  const end = new Date(baseDate);
  end.setHours(7, 30, 0, 0);

  setNewEventTitle('');
  setNewEventStart(start);
  setNewEventEnd(end);
  setNewEventDescription('');
  setNewEventType('Appointment');
  setNewEventColor('#007bff');
  setCreateEventDialogOpen(true);
};

  const handleCreateEventSubmit = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/event/create`, {
        title: newEventTitle,
        description: newEventDescription,
        start_datetime: newEventStart,
        end_datetime: newEventEnd,
        allDay: false,
        location: newEventLocation,
        eventType: newEventType,
        category: '',
        recurrenceRule: '', 
        relatedOrderId: ''
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      if (response.status === 201) {
        // Refresh events or add new event locally
        setEvents(prev => [...prev, {
          eventId: response.data.event_id,
          title: newEventTitle,
          start: new Date(newEventStart),
          end: new Date(newEventEnd),
          description: newEventDescription,
          eventType: newEventType,
          color: newEventColor,
        }]);
        setCreateEventDialogOpen(false);
        toast.success('Event created successfully');
        window.location.reload();
      } else {
        toast.error('Failed to create event');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to create event');
    }
  };

  const handleCreateEventCancel = () => {
    setCreateEventDialogOpen(false);
  };

  const handleDateClick = (arg) => {
    const clickedDate = arg.date;
    const eventsOnThisDay = events.filter(event => 
      new Date(event.start).toDateString() === clickedDate.toDateString()
    );
    setSelectedDate(clickedDate);
    setSelectedDateEvents(eventsOnThisDay);
  };

  const [editEventDialogOpen, setEditEventDialogOpen] = useState(false);
  const [editEventData, setEditEventData] = useState(null);

  const handleEventClick = (event) => {
    setEditEventData(event);
    setEditEventDialogOpen(true);
  };

  const handleEditEventChange = (field, value) => {
    setEditEventData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleEditEventSubmit = async () => {
    try {
      const response = await axios.put(`${API_BASE_URL}/event/update/${editEventData.eventId}`, {
        title: editEventData.title,
        start_datetime: editEventData.start instanceof Date ? editEventData.start.toISOString() : editEventData.start,
        end_datetime: editEventData.end instanceof Date ? editEventData.end.toISOString() : editEventData.end,
        description: editEventData.description,
        event_type: editEventData.eventType,
        color: editEventData.color,
        location: editEventData.location || null,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          selectedorg: orgId,
        },
      });

      if (response.status === 200) {
        setEvents(prev => prev.map(ev => ev.eventId === editEventData.eventId ? editEventData : ev));
        setEditEventDialogOpen(false);
        toast.success('Event updated successfully');
        window.location.reload();
      } else {
        toast.error('Failed to update event');
      }
    } catch (error) {
      console.error('Error updating event:', error);
      toast.error('Failed to update event');
    }
  };

  function formatLocalDateTimeForInput(date) {
    if (!date) return '';
    const d = new Date(date);
    const pad = (n) => n.toString().padStart(2, '0');
    return (
      d.getFullYear() + '-' +
      pad(d.getMonth() + 1) + '-' +
      pad(d.getDate()) + 'T' +
      pad(d.getHours()) + ':' +
      pad(d.getMinutes())
    );
  }

  const handleEditEventCancel = () => {
    setEditEventDialogOpen(false);
    setEditEventData(null);
  };

  const handleLayoutChange = (event, newLayout) => {
    if (newLayout !== null) {
      setLayoutMode(newLayout);
    }
  };

  let updatedOrder = {};

  const JobFlowStepper = ({ jobFlowSteps, currentStep }) => {
    const [hoveredStep, setHoveredStep] = useState(null);
    const prevStepRef = useRef(currentStep);
    const timeoutRef = useRef(null);

    const [animatingStep, setAnimatingStep] = useState(null);

    useEffect(() => {
      if (prevStepRef.current !== currentStep) {
        setAnimatingStep(currentStep);
        const timeout = setTimeout(() => setAnimatingStep(null), 600);
        prevStepRef.current = currentStep;
        return () => clearTimeout(timeout);
      }
    }, [currentStep]);

    const handleMouseLeave = () => {
      // timeoutRef.current = setTimeout(() => {
        setHoveredStep(null);
      // }, 450);
    };

    const handleMouseEnter = (stepNumber) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setHoveredStep(stepNumber);
    };

    return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          userSelect: 'none',
          fontSize: 12,
          fontWeight: 500,
          cursor: 'default',
          overflow: 'hidden',
          borderRadius: 0,
          boxShadow: 'inset 0 0 5px rgba(0,0,0,0.1)',
          backgroundColor: '#ddd',
        }}
        onMouseLeave={handleMouseLeave}
      >
        {jobFlowSteps.map((step, index) => {
          const isCurrent = step.step_number === currentStep;
          const isHovered = hoveredStep === step.step_number;
          const isAnimating = animatingStep === step.step_number;

          const expanded = isHovered || (!hoveredStep && isCurrent);
          const flexGrow = expanded ? 3 : 1;

          // Change here: previous steps have white background and black text
          const isPreviousStep = step.step_number < currentStep;
          const backgroundColor = isPreviousStep ? '#fff' : step.step_color;
          const color = isPreviousStep ? '#999' : '#fff';

          return (
            <div
              key={step.step_number}
              onMouseEnter={() => handleMouseEnter(step.step_number)}
              style={{
                backgroundColor,
                color,
                padding: '4px 10px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flexGrow,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 600,
                cursor: 'default',
                userSelect: 'none',
                height: 28,
                marginLeft: index === 0 ? 0 : -8,
                borderRadius: 0,
                boxShadow: isAnimating ? '0 0 8px 2px rgba(255,255,255,0.7)' : 'none',
                transform: isAnimating ? 'scale(1.05)' : 'none',
                zIndex: isAnimating ? 10 : 'auto',
                position: 'relative',
                backfaceVisibility: 'hidden',
                willChange: 'transform, flex-grow',
                pointerEvents: 'auto',
              }}
            >
              {expanded ? step.step_name : step.step_name.charAt(0).toUpperCase()}
              {index !== jobFlowSteps.length - 1 && (
                <div
                  style={{
                    position: 'absolute',
                    right: -8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 0,
                    height: 0,
                    borderTop: '14px solid transparent',
                    borderBottom: '14px solid transparent',
                    borderLeft: `14px solid ${backgroundColor}`,
                    zIndex: 1,
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };
  

  


  const handleJobFlowChange = (value) => {
    setSelectedJobFlow(value);
  };

  if (loading1 || loading2 || loading3 || loading4) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 64px)',
        backgroundColor: '#fff',
      }}>
        <img src={loadingGif} alt="Loading..." style={{ width: '30%', height: '30%', objectFit: 'contain' }} />
      </div>
    );
  }

  return (
    <>
     <div style={{ marginBottom: 0, display: 'flex', justifyContent: 'center' }}>
      <ToggleButtonGroup
        value={layoutMode}
        exclusive
        onChange={handleLayoutChange}
        aria-label="layout mode"
        size="medium"
        fullWidth
        sx={{
          backgroundColor: '#f9f9f9',
          display: 'flex',
          width: '100%',
          minWidth: '100%',
          maxWidth: 600,
          '& .MuiToggleButton-root': {
            border: 'none',
            borderBottom: '2px solid transparent',
            color: '#666',
            flex: 1,
            px: 0,
            py: 1,
            fontWeight: '600',
            textTransform: 'none',
            borderRadius: 0,
            justifyContent: 'center',
            transition: 'color 0.3s ease, border-bottom-color 0.3s ease',
            backgroundColor: 'transparent',
            '&:hover': {
              color: '#444',
              backgroundColor: 'transparent',
            },
          },
          '& .MuiToggleButton-root.Mui-selected': {
            color: '#222',
            borderBottomColor: '#1976d2',
            backgroundColor: 'transparent',
            fontWeight: '700',
          },
        }}
      >
        <ToggleButton value="order" aria-label="order only" title="Order Only">
          <ViewListIcon sx={{ mr: 1, color: 'inherit' }} />
          Order
        </ToggleButton>

        <ToggleButton value="split" aria-label="split view" title="Split View">
          <VerticalSplitIcon sx={{ mr: 1, color: 'inherit' }} />
          Split View
        </ToggleButton>

        <ToggleButton value="calendar" aria-label="calendar only" title="Calendar Only">
          <CalendarTodayIcon sx={{ mr: 1, color: 'inherit' }} />
          Calendar
        </ToggleButton>
      </ToggleButtonGroup>
    </div>

      <div 
        className="create-order-container" 
        style={{ 
          display: 'flex', 
          flexDirection: layoutMode === 'split' ? 'row' : 'column',
          gap: layoutMode === 'split' ? '0' : '-rem',
          height: 'calc(100vh - 110px)',
          overflowY: 'auto'
        }}
      >
         {(layoutMode === 'order' || layoutMode === 'split') && (
            <div className="data-entry">
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                connector={<CustomConnector />}
                sx={{
                  background: 'transparent',
                  padding: '24px 0 16px 0',
                  '.MuiStepLabel-label': {
                    fontWeight: 600,
                    fontSize: 16,
                    color: '#3e5570',
                  },
                  '.MuiStepLabel-root.Mui-active .MuiStepLabel-label': {
                    color: 'primary.main',
                  },
                  '.MuiStepLabel-root.Mui-completed .MuiStepLabel-label': {
                    color: 'primary.main',
                  },
                }}
              >
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>

              <div>
                {activeStep === 0 && (
                  <div>
                    <h3>Customer Type</h3>
                    <Select
                      value={customerType}
                      onChange={(e) => handleCustomerTypeChange(e.target.value)}
                      displayEmpty
                      fullWidth
                    >
                      <MenuItem value="company">Company</MenuItem>
                      <MenuItem value="individual">Individual</MenuItem>
                    </Select>

                    {/* Form for Company Customer */}
                    {customerType === 'company' ? (
                      <div>
                        <h3>Company Details</h3>
                        <Select
                          value={selectedCompany || "0"}
                          onChange={(e) => handleCompanyChange(e.target.value)}
                          displayEmpty
                          fullWidth
                        >
                          <MenuItem value="0">* Select Existing Company *</MenuItem>
                          {companyMap
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((company) => (
                              <MenuItem key={company.id} value={company.id}>
                                {company.name}
                              </MenuItem>
                          ))}
                        </Select>
                        <TextField
                          label="Company Name"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCompany !== '0'}
                        />
                        <TextField
                          label="Company Number"
                          value={companyNumber}
                          onChange={(e) => setCompanyNumber(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCompany !== '0'}
                        />
                        <TextField
                          label="Company Email"
                          type="email"
                          value={companyEmail}
                          onChange={(e) => setCompanyEmail(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCompany !== '0'}
                        />
                        <TextField
                          label="Company Website"
                          value={companyWebsite}
                          onChange={(e) => setCompanyWebsite(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCompany !== '0'}
                        />
                        <h3>Customer Details</h3>
                        <Select
                          value={selectedCompanyCustomer}
                          onChange={(e) => handleCompanyCustomerChange(e.target.value)}
                          displayEmpty
                          fullWidth
                        >
                          <MenuItem value="0">* Select Existing Customer *</MenuItem>
                          {companyCustomerMap
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .sort((a, b) => a.number.localeCompare(b.number))
                            .sort((a, b) => a.email.localeCompare(b.email))
                            .map((customer) => (
                              <MenuItem key={customer.id} value={customer.id}>
                              {customer.name}
                            </MenuItem>
                          ))}                      
                        </Select>
                        <TextField
                          label="Customer Name"
                          value={companyCustomerName}
                          onChange={(e) => setCompanyCustomerName(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCompanyCustomer !== '0'}
                        />
                        <TextField
                          label="Customer Number"
                          value={companyCustomerNumber}
                          onChange={(e) => setCompanyCustomerNumber(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCompanyCustomer !== '0'}
                        />
                        <TextField
                          label="Customer Email"
                          type="email"
                          value={companyCustomerEmail}
                          onChange={(e) => setCompanyCustomerEmail(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCompanyCustomer !== '0'}
                        />
                      </div>
                    ) : (
                      <div>
                        <h3>Customer Details</h3>
                        <Select
                          value={selectedCustomer}
                          onChange={(e) => handleCustomerChange(e.target.value)}
                          displayEmpty
                          fullWidth
                        >
                          <MenuItem value="0">* New Customer *</MenuItem>
                          {customerMap
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .sort((a, b) => a.number.localeCompare(b.number))
                            .sort((a, b) => a.email.localeCompare(b.email))
                            .map((customer) => (
                            <MenuItem key={customer.id} value={customer.id}>
                              {customer.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <TextField
                          label="Customer Name"
                          value={customerName}
                          onChange={(e) => setCustomerName(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCustomer !== '0'}
                        />
                        <TextField
                          label="Customer Number"
                          value={customerNumber}
                          onChange={(e) => setCustomerNumber(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCustomer !== '0'}
                        />
                        <TextField
                          label="Customer Email"
                          type="email"
                          value={customerEmail}
                          onChange={(e) => setCustomerEmail(e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                          disabled={selectedCustomer !== '0'}
                        />
                      </div>
                    )}
                  </div>
                )}

                {activeStep === 1 && (
                  <div>
                    <h3>Order Job Flow</h3>
                    <Select
                      labelId="job-flow-select-label"
                      value={selectedJobFlow || ""}
                      onChange={(e) => handleJobFlowChange(e.target.value)}
                      displayEmpty
                      fullWidth
                    >
                      <MenuItem value="" disabled>
                        Select a Job Flow
                      </MenuItem>
                      {jobFlow.map((flow) => (
                        <MenuItem key={flow.id} value={flow.id}>
                          {flow.flow_name}
                        </MenuItem>
                      ))}
                    </Select>
                    <h3>Order Prefix</h3>
                    <Select
                      value={orderPrefix}
                      onChange={(e) => handleOrderPrefixChange(e.target.value)}
                      fullWidth
                    >
                      {prefixMap.map((prefix) => (
                        <MenuItem key={prefix.id} value={prefix.prefix}>
                          {prefix.prefix}
                        </MenuItem>
                      ))}
                    </Select>
                    <h3>Tags</h3>
                    <Box display="flex" justifyContent="space-between">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag1}
                            onChange={(e) => setTag1(e.target.checked)}
                            name="tag1"
                          />
                        }
                        label={tag1Name}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag2}
                            onChange={(e) => setTag2(e.target.checked)}
                            name="tag2"
                          />
                        }
                        label={tag2Name}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag3}
                            onChange={(e) => setTag3(e.target.checked)}
                            name="tag3"
                          />
                        }
                        label={tag3Name}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag4}
                            onChange={(e) => setTag4(e.target.checked)}
                            name="tag4"
                          />
                        }
                        label={tag4Name}
                      />
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag5}
                            onChange={(e) => setTag5(e.target.checked)}
                            name="tag5"
                          />
                        }
                        label={tag5Name}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag6}
                            onChange={(e) => setTag6(e.target.checked)}
                            name="tag6"
                          />
                        }
                        label={tag6Name}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag7}
                            onChange={(e) => setTag7(e.target.checked)}
                            name="tag7"
                          />
                        }
                        label={tag7Name}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tag8}
                            onChange={(e) => setTag8(e.target.checked)}
                            name="tag8"
                          />
                        }
                        label={tag8Name}
                      />
                    </Box>
                    <h3>Order Details</h3>
                    <TextField
                      label="Quote #"
                      value={quoteNumber}
                      onChange={(e) => setQuoteNumber(e.target.value)}
                      multiline
                      rows={1}
                      margin="normal"
                      inputProps={{ maxLength: 255 }}
                    />
                    <TextField
                      label="Purchase Order #"
                      value={purchaseOrder}
                      onChange={(e) => setPurchaseOrder(e.target.value)}
                      multiline
                      rows={1}
                      margin="normal"
                      inputProps={{ maxLength: 255 }}
                    />
                    <TextField
                      label="Invoice #"
                      value={invoiceNumber}
                      onChange={(e) => setInvoiceNumber(e.target.value)}
                      multiline
                      rows={1}
                      margin="normal"
                      inputProps={{ maxLength: 255 }}
                    />
                    <TextField
                      label="Folder Path"
                      value={folderPath}
                      onChange={(e) => setFolderPath(e.target.value)}
                      multiline
                      rows={2}
                      margin="normal"
                      inputProps={{ maxLength: 255 }}
                    />
                    <TextField
                      label="Order Description"
                      value={orderDescription}
                      onChange={(e) => setOrderDescription(e.target.value)}
                      multiline
                      rows={4}
                      margin="normal"
                      inputProps={{ maxLength: 1000 }}
                    />
                    <h3>Order Address</h3>
                    <TextField
                      label="Street Address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      multiline
                      rows={1}
                      margin="normal"
                      inputProps={{ maxLength: 255 }}
                    />
                    <TextField
                      label="Suburb"
                      value={suburb}
                      onChange={(e) => setSuburb(e.target.value)}
                      multiline
                      rows={1}
                      margin="normal"
                      inputProps={{ maxLength: 255 }}
                    />
                    <TextField
                      label="State"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      multiline
                      rows={1}
                      margin="normal"
                      inputProps={{ maxLength: 255 }}
                    />
                    <TextField
                      label="Postal Code"
                      value={postalCode}
                      onChange={(e) => setPostalCode(e.target.value)}
                      multiline
                      rows={1}
                      margin="normal"
                      inputProps={{ maxLength: 4 }}
                    />
                  </div>
                )}
                {activeStep === 2 && (
                  <div>
                    {jobs.map((job, index) => (
                      <div className="job-card" key={job.id}>
                        <Box display="flex" alignItems="center" gap={4}>
                          <Tooltip title={job.urgent ? 'Urgent job enabled' : 'Mark as urgent'}>
                            <FlameToggle urgent={job.urgent} onClick={() => updateJob(job.id, 'urgent', !job.urgent)}>
                              <AnimatedFlame urgent={job.urgent} />
                              <Typography variant="body2" style={{ marginLeft: 8, color: job.urgent ? '#d35400' : '#757575', fontWeight: 500 }}>
                                <h3 style={{ margin: 0 }}>{`Job ${job.id}`}</h3>
                              </Typography>
                            </FlameToggle>
                          </Tooltip>
                        </Box>
                        <TextField
                          label="Job Name"
                          value={job.jobName}
                          onChange={(e) => updateJob(job.id, 'jobName', e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                        />
                        <TextField
                          label="Job Description"
                          value={job.jobDescription}
                          onChange={(e) => updateJob(job.id, 'jobDescription', e.target.value)}
                          multiline
                          rows={4}
                          margin="normal"
                          inputProps={{ maxLength: 1000 }}
                        />
                        <Button 
                          onClick={() => {
                            setAllProductsDialogOpen(true);
                            setSelectedProductJobId(job.id);
                            setEditingJobProducts(job.product || []);
                          }}
                          variant="contained"
                          color="primary"
                          sx={{ mt: 2 }}
                          alignItems="center"
                          justifyContent="center"
          
                        >
                          Select Products
                        </Button>
                        {Array.isArray(job.product) && job.product.length > 0 && (
                          <div>
                            <Typography variant="h6" className="selected-products-title" sx={{ mb: -2 }}>
                              Job Products
                            </Typography>
                            <Table sx={{ minWidth: 650, border: '1px solid #e0e0e0', background: '#fff', mt: 2 }}>
                              <TableHead>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 600, background: '#f5f5f5', borderRight: '1px solid #e0e0e0' }}>Item Name</TableCell>
                                  <TableCell sx={{ fontWeight: 600, background: '#f5f5f5', borderRight: '1px solid #e0e0e0' }}>Quantity</TableCell>
                                  <TableCell sx={{ fontWeight: 600, background: '#f5f5f5', borderRight: '1px solid #e0e0e0' }}>Price</TableCell>
                                  <TableCell sx={{ fontWeight: 600, background: '#f5f5f5', borderRight: '1px solid #e0e0e0' }}>Subtotal</TableCell>
                                  <TableCell sx={{ fontWeight: 600, background: '#f5f5f5' }}>Remove</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {job.product && job.product.length > 0 ? (
                                  job.product.map((product) => (
                                    <TableRow key={product.product_item_id}>
                                      <TableCell sx={{ borderRight: '1px solid #e0e0e0', width: 220 }}>{product.item_name}</TableCell>
                                      <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>{product.quantity}</TableCell>
                                      <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>
                                        ${product.item_price}/{getUnitNameById(product.item_unit)}
                                      </TableCell>
                                      <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>
                                        {(product.quantity * product.item_price).toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        <IconButton onClick={() => removeProductFromJob(product.product_item_id, job.id)}>
                                          <img src={deleteIcon} alt="Delete" style={{ width: 20, height: 20 }} />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={6} sx={{ textAlign: 'center', color: '#bdbdbd' }}>
                                      No products added
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </div>
                        )}
                        <TextField
                          label="Price"
                          value={job.price}
                          onChange={(e) => updateJob(job.id, 'price', e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                        />
                        {/*
                        <TextField
                          label="Job Note"
                          value={job.jobNote}
                          onChange={(e) => updateJob(job.id, 'jobNote', e.target.value)}
                          multiline
                          rows={1}
                          margin="normal"
                          inputProps={{ maxLength: 255 }}
                        />
                        */}
                        <img
                          src={deleteIcon}
                          alt="Delete"
                          className="delete-job-icon"
                          onClick={() => deleteJob(job.id)}
                        />
                      </div>
                    ))}

                    <div className="add-job-btn-container">
                      <Button variant="contained" color="primary" onClick={addJob}>
                        Add Job
                      </Button>
                    </div>
                  </div>
                )}
                {activeStep === 3 && (
                  <Box className="review-container" sx={{ p: 3, background: '#fafbfc', borderRadius: 3 }}>
                    {/* Customer Details Section */}
                    <Grid item xs={12} md={6} sx={{ mb: 3 }}>
                      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, background: '#f5faff' }}>
                        <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                          Customer Details
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={companyName !== '' ? 6 : 12}>
                            <Box sx={{ p: 2, borderRadius: 2, background: '#fff', boxShadow: 1 }}>
                              <Typography variant="overline" color="primary.main">Customer</Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <PersonIcon sx={{ mr: 1, color: 'primary.main' }} />
                                <Typography variant="h6">{companyName !== '' ? companyCustomerName : customerName}</Typography>
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <EmailIcon sx={{ mr: 1, color: 'primary.main' }} />
                                <Typography variant="body2" color="text.secondary">{companyName !== '' ? companyCustomerEmail : customerEmail}</Typography>
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <PhoneIcon sx={{ mr: 1, color: 'primary.main' }} />
                                <Typography variant="body2" color="text.secondary">{companyName !== '' ? companyCustomerNumber : customerNumber}</Typography>
                              </Box>
                            </Box>
                          </Grid>
                          {companyName !== '' && (
                            <Grid item xs={12} sm={6}>
                              <Divider orientation="vertical" flexItem sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }} />
                              <Box sx={{ p: 2, borderRadius: 2, background: '#fff', boxShadow: 1 }}>
                                <Typography variant="overline" color="secondary.main">Company</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                  <BusinessIcon sx={{ mr: 1, color: 'secondary.main' }} />
                                  <Typography variant="h6">{companyName}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                  <EmailIcon sx={{ mr: 1, color: 'secondary.main' }} />
                                  <Typography variant="body2" color="text.secondary">{companyEmail}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                  <PhoneIcon sx={{ mr: 1, color: 'secondary.main' }} />
                                  <Typography variant="body2" color="text.secondary">{companyNumber}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                  <LanguageIcon sx={{ mr: 1, color: 'secondary.main' }} />
                                  <Typography variant="body2" color="text.secondary">{companyWebsite}</Typography>
                                </Box>
                              </Box>
                            </Grid>
                          )}
                        </Grid>
                      </Paper>
                    </Grid>
                    {/* Order Details Section */}
                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, mb: 3, background: '#f5faff' }}>
                      <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                        Order Details
                      </Typography>
                      <Divider sx={{ mb: 2 }} />
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Grid item xs={12}>
                            <Grid container spacing={1} alignItems="center">
                              <Grid item xs={3}>
                                <Typography variant="body2" color="text.secondary">Job Flow</Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !selectedJobFlow ? '#bdbdbd' : 'inherit' }}>
                                  {(jobFlow.find(flow => flow.id === selectedJobFlow)?.flow_name) || 'N/A'}
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2" color="text.secondary">Order Prefix</Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !orderPrefix ? '#bdbdbd' : 'inherit' }}>
                                  {orderPrefix || 'N/A'}
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2" color="text.secondary">Invoice #</Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !invoiceNumber ? '#bdbdbd' : 'inherit' }}>
                                  {invoiceNumber || 'N/A'}
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2" color="text.secondary">Purchase Order</Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !purchaseOrder ? '#bdbdbd' : 'inherit' }}>
                                  {purchaseOrder || 'N/A'}
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2" color="text.secondary">Quote #</Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !quoteNumber ? '#bdbdbd' : 'inherit' }}>
                                  {quoteNumber || 'N/A'}
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2" color="text.secondary">Folder Path</Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !folderPath ? '#bdbdbd' : 'inherit' }}>
                                  {folderPath || 'N/A'}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}><Divider /></Grid>

                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#e7f5ff', borderRadius: 2, p: 1 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>{tag1Name}</Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: tag1 ? '#208de6ff' : '#bdbdbd', ml: 2 }}>{tag1 ? 'Yes' : 'No'}</Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#e7f5ff', borderRadius: 2, p: 1 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>{tag2Name}</Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: tag2 ? '#208de6ff' : '#bdbdbd', ml: 2 }}>{tag2 ? 'Yes' : 'No'}</Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#e7f5ff', borderRadius: 2, p: 1 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>{tag3Name}</Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: tag3 ? '#208de6ff' : '#bdbdbd', ml: 2 }}>{tag3 ? 'Yes' : 'No'}</Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#e7f5ff', borderRadius: 2, p: 1 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>{tag4Name}</Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: tag4 ? '#208de6ff' : '#bdbdbd', ml: 2 }}>{tag4 ? 'Yes' : 'No'}</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}><Divider /></Grid>

                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Grid container spacing={1} alignItems="center">
                                <Grid item xs={3}>
                                  <Typography variant="body2" color="text.secondary">Address</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                  <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !address ? '#bdbdbd' : 'inherit' }}>
                                    {address || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                  <Typography variant="body2" color="text.secondary">Suburb</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                  <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !suburb ? '#bdbdbd' : 'inherit' }}>
                                    {suburb || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                  <Typography variant="body2" color="text.secondary">State</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                  <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !state ? '#bdbdbd' : 'inherit' }}>
                                    {state || 'N/A'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                  <Typography variant="body2" color="text.secondary">Postcode</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                  <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !postalCode ? '#bdbdbd' : 'inherit' }}>
                                    {postalCode || 'N/A'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body2" color="text.secondary">Order Description</Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !orderDescription ? '#bdbdbd' : 'inherit' }}>
                            {orderDescription || 'N/A'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                    <Paper elevation={2} sx={{ mb: 3, p: 2, borderRadius: 2 }}>
                      <Typography variant="h6" gutterBottom>Job Details</Typography>
                      {jobs.map((job) => (
                        <Box key={job.id} sx={{ mb: 3, p: 2, borderRadius: 2, background: '#f5faff', boxShadow: 1 }}>
                          <Box display="flex" alignItems="center" gap={4} mb={2}>
                          <Tooltip>
                            <FlameToggle urgent={job.urgent} onClick={() => updateJob(job.id, 'urgent', !job.urgent)}>
                              <AnimatedFlame urgent={job.urgent} />
                              <Typography variant="body2" style={{ marginLeft: 8, color: job.urgent ? '#d35400' : '#757575', fontWeight: 500 }}>
                                <h3 style={{ margin: 0 }}>{job.jobName}</h3>
                                {console.log(job)}
                              </Typography>
                            </FlameToggle>
                          </Tooltip>
                        </Box>
                          <Divider sx={{ mb: 2 }} />
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={3}>
                              <Typography variant="body2" color="text.secondary">Price</Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !job.price ? '#bdbdbd' : 'inherit' }}>
                                {job.price ? `${job.price}` : 'N/A'}
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Typography variant="body2" color="text.secondary">Job Note</Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !job.jobNote ? '#bdbdbd' : 'inherit' }}>
                                {job.jobNote || 'N/A'}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">Job Description</Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: 'break-all', background: '#fff', p: 1, borderRadius: 1, color: !job.jobDescription ? '#bdbdbd' : 'inherit' }}>
                              {job.jobDescription || 'N/A'}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} mt={2}>
                            <Table sx={{ border: '1px solid #e0e0e0', background: '#fff' }}>
                              <TableHead>
                                <TableRow>
                                  <TableCell sx={{ background: '#f5f5f5', borderRight: '1px solid #e0e0e0', width: '50%' }}>Product</TableCell>
                                  <TableCell sx={{ background: '#f5f5f5', borderRight: '1px solid #e0e0e0' }}>Quantity</TableCell>
                                  <TableCell sx={{ background: '#f5f5f5', borderRight: '1px solid #e0e0e0' }}>Price</TableCell>
                                  <TableCell sx={{ background: '#f5f5f5' }}>Subtotal</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {job.product && job.product.length > 0 ? (
                                  job.product.map((product, idx) => (
                                    <TableRow key={idx}>
                                      <TableCell sx={{ borderRight: '1px solid #e0e0e0', width: 220 }}>{product.item_name || <span style={{color:'#bdbdbd'}}>N/A</span>}</TableCell>
                                      <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>{product.quantity && getUnitNameById(product.item_unit) ? `${product.quantity} ${getUnitNameById(product.item_unit)}` : <span style={{color:'#bdbdbd'}}>N/A</span>}</TableCell>
                                      <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>{product.item_price ? `$${product.item_price}` : <span style={{color:'#bdbdbd'}}>N/A</span>}</TableCell>
                                      <TableCell>{product.quantity && product.item_price ? `$${(product.quantity * product.item_price).toFixed(2) || 0.00}` : <span style={{color:'#bdbdbd'}}>N/A</span>}</TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={4} sx={{ textAlign: 'center', color: '#bdbdbd' }}>
                                      No products added
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </Grid>
                        </Grid>
                        </Box>
                      ))}
                    </Paper>
                  </Box>
                )}

                <Box display="flex" justifyContent="space-between" mt={2}>
                  <Button
                    variant="contained"
                    color="#fff"
                    onClick={() => setActiveStep(activeStep - 1)}
                    disabled={activeStep === 0}
                  >
                    Back
                  </Button>
                  {activeStep === steps.length - 1 ? (
                    <Button
                      variant="contained"
                      onClick={handleSubmitOrder}
                    >
                      Submit Order
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      onClick={() => setActiveStep(activeStep + 1)}
                    >
                      Next
                    </Button>
                  )}
                </Box>
              </div>
            </div>
          )}
          {(layoutMode === 'calendar' || layoutMode === 'split') && (
            <>
              <style>
                {`
                  .calendar-container {
                    position: relative;
                    transition: opacity 0.5s ease;
                  }
                  .calendar-container.dimmed {
                    opacity: 0.3;
                    pointer-events: none;
                  }
                  .event-list-overlay {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    right: 10px;
                    bottom: 10px;
                    background: white;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                    border-radius: 8px;
                    padding: 20px;
                    overflow-y: auto;
                    opacity: 0;
                    animation: fadeIn 0.5s forwards;
                    z-index: 2000;
                  }
                  @keyframes fadeIn {
                    to {
                      opacity: 1;
                    }
                  }
                  .event-list-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 1rem;
                  }
                  .event-list-close-btn {
                    cursor: pointer;
                    background: none;
                    border: none;
                    font-size: 1.5rem;
                    font-weight: bold;
                    line-height: 1;
                  }
                  .event-item {
                    padding: 10px 0;
                    border-bottom: 1px solid #ddd;
                    cursor: pointer;
                  }
                  .event-item:last-child {
                    border-bottom: none;
                  }
                  .event-item:hover {
                    background-color: #f0f0f0;
                  }
                `}
              </style>

              <div
                className={`calendar-container`}
                style={{
                  flex: layoutMode === 'split' ? 1 : 'unset',
                  width: layoutMode === 'split' ? '50%' : '100%',
                  marginLeft: 0,
                  marginTop: layoutMode === 'split' ? 0 : 0,
                  height: layoutMode === 'split' ? 'auto' : 'calc(100vh - 105px)',
                  backgroundColor: '#fff',
                  padding: '10px',
                  boxSizing: 'border-box',
                  borderRadius: 0,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
              >
                {selectedDate && (
                  <EventPanel 
                    date={selectedDate} 
                    events={selectedDateEvents} 
                    onClose={() => setSelectedDate(null)} 
                    onAddEvent={handleAddEvent}
                    handleEventClick={handleEventClick}
                  />
                )}
                <FullCalendar
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  headerToolbar={{
                    left: 'prev,today,next',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay',
                  }}
                  events={events}
                  selectable={true}
                  dateClick={handleDateClick}
                  height="100%"
                  nowIndicator={true}
                  eventTimeFormat={{
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                  }}
                  eventClick={(info) => {
                    handleDateClick({ date: info.event.start });
                  }}    
                />
              </div>
            </>
          )}
      </div>
      
      <Dialog open={createEventDialogOpen} onClose={handleCreateEventCancel} maxWidth="sm" fullWidth>
        <DialogTitle style={{ color: 'black', whiteSpace: 'normal' }}>
          Create New Event
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Title"
            fullWidth
            margin="normal"
            value={newEventTitle}
            onChange={(e) => setNewEventTitle(e.target.value)}
            multiline
            rows={1}
            required
          />
          <TextField
            label="Description"
            fullWidth
            margin="normal"
            multiline
            rows={1}
            value={newEventDescription}
            onChange={(e) => setNewEventDescription(e.target.value)}
          />
          <TextField
            label="Start Time"
            type="datetime-local"
            fullWidth
            margin="normal"
            value={newEventStart ? new Date(newEventStart).toISOString().slice(0,16) : ''}
            onChange={(e) => setNewEventStart(new Date(e.target.value))}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Time"
            type="datetime-local"
            fullWidth
            margin="normal"
            value={newEventEnd ? new Date(newEventEnd).toISOString().slice(0,16) : ''}
            onChange={(e) => setNewEventEnd(new Date(e.target.value))}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Location"
            fullWidth
            multiline
            row={1}
            margin="normal"
            value={newEventLocation || ''}
            onChange={(e) => setNewEventLocation(e.target.value)}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="event-type-label">Event Type</InputLabel>
            <Select
              labelId="event-type-label"
              value={newEventType}
              label="Event Type"
              onChange={(e) => setNewEventType(e.target.value)}
            >
              <MenuItem value="Appointment">Appointment</MenuItem>
              <MenuItem value="Task">Task</MenuItem>
              <MenuItem value="Leave">Leave</MenuItem>
              <MenuItem value="Reminder">Reminder</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCreateEventCancel}>Cancel</Button>
          <Button variant="contained" onClick={handleCreateEventSubmit} disabled={!newEventTitle || !newEventStart || !newEventEnd}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer position="top-right" autoClose={3000} limit={5} />
      <Dialog open={editEventDialogOpen} onClose={handleEditEventCancel} maxWidth="sm" fullWidth>
        <DialogTitle style={{ color: 'black', whiteSpace: 'normal' }}>Edit Event</DialogTitle>
        <DialogContent>
          <TextField
            label="Title"
            fullWidth
            multiline
            rows={1}
            margin="normal"
            value={editEventData?.title || ''}
            onChange={(e) => handleEditEventChange('title', e.target.value)}
          />
          <TextField
            label="Description"
            fullWidth
            margin="normal"
            multiline
            rows={1}
            value={editEventData?.description || ''}
            onChange={(e) => handleEditEventChange('description', e.target.value)}
          />
          <TextField
            label="Start"
            type="datetime-local"
            fullWidth
            margin="normal"
            value={editEventData?.start ? formatLocalDateTimeForInput(editEventData.start) : ''}
            onChange={(e) => handleEditEventChange('start', new Date(e.target.value))}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End"
            type="datetime-local"
            fullWidth
            margin="normal"
            value={editEventData?.end ? formatLocalDateTimeForInput(editEventData.end) : ''}
            onChange={(e) => handleEditEventChange('end', new Date(e.target.value))}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Location"
            fullWidth
            multiline
            rows={1}
            margin="normal"
            value={editEventData?.location || ''}
            onChange={(e) => handleEditEventChange('location', e.target.value)}
          />
          <Select
            label="Event Type"
            fullWidth
            margin="normal"
            value={editEventData?.eventType || ''}
            onChange={(e) => handleEditEventChange('eventType', e.target.value)}
            disabled={editEventData?.eventType === 'Job Schedule'}
            inputProps={{ 'aria-label': 'Event Type' }}
            style={{ marginTop: 16, marginBottom: 8 }}
          >
            {/* Exclude 'Job Schedule' from selectable options */}
            {['Appointment', 'Task', 'Leave', 'Reminder', 'Other'].map(type => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}

            {/* If current eventType is 'Job Schedule', show it as a disabled option */}
            {editEventData?.eventType === 'Job Schedule' && (
              <MenuItem value="Job Schedule" disabled>
                Job Schedule
              </MenuItem>
            )}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditEventCancel}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleEditEventSubmit}>Save</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={allProductsDialogOpen}
        onClose={closeAllProductsDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle style={{ color: 'black' }}>Add Products for Job</DialogTitle>
        <DialogContent dividers style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <TextField
            label="Search products"
            variant="outlined"
            fullWidth
            multiline
            rows={1}
            margin="normal"
            value={productSearchTerm}
            onChange={e => setProductSearchTerm(e.target.value)}
            placeholder="Search by product name, category, or department"
          />

          {loadingProducts ? (
            <div>Loading products...</div>
          ) : filteredProducts.length === 0 ? (
            <div>No products found.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Department</th>
                  <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Category</th>
                  <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Product Name</th>
                  <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Price</th>
                  <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Stock</th>
                  <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Unit</th>
                  <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts.map(product => {
                  const existingProduct = editingJobProducts.find(p => p.product_item_id === product.product_item_id);
                  const quantity = existingProduct ? existingProduct.quantity : 0;
                  return (
                    <tr key={product.product_item_id}>
                      <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{product.departmentName || 'N/A'}</td>
                      <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{product.categoryName || 'N/A'}</td>
                      <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{product.item_name}</td>
                      <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>{Number(product.item_price).toFixed(2)}</td>
                      <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>{product.item_stock}</td>
                      <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{getUnitNameById(product.item_unit) || product.item_unit || 'N/A'}</td>
                      <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>
                        <TextField
                        type="number"
                        inputProps={{ min: 0 }}
                        value={quantity}
                        onChange={e => handleProductQuantityChange(product.product_item_id, e.target.value)}
                        variant="outlined"
                        size="small"
                        style={{ width: '80px' }}
                      />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAllProductsDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={() => saveJobProducts()} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateNewOrder;
